import { SECRET_INPUT_TYPE, SELECT_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";

const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{8,}$/;
const PASSWORD_ERROR = "Debe tener al menos 8 caracteres y una mayúscula, una minúscula, un número y un símbolo";

/**
 * Configuracion del formulario admin de alta/edicion de usuario de una suscripcion.
 * Los roles provienen del tenant objetivo (no del usuario logueado).
 */
export const buildAdminTenantUserFormConfig = (
    roles: Record<string, string>,
    isEdit: boolean
) => {
    const fields: any[] = [
        [
            {
                "type": "hidden",
                "name": "id",
            },
        ],
        [
            {
                "type": "text",
                "name": "name",
                "label": "Nombre",
                "isHorizontal": true,
                "sizing": { "sm": 8 },
                "labelSizing": { "sm": 3 },
                "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
            },
        ],
        [
            {
                "type": "text",
                "name": "email",
                "label": "Email",
                "isHorizontal": true,
                "isDisabled": isEdit,
                "sizing": { "sm": 8 },
                "labelSizing": { "sm": 3 },
                "validation": Yup.string().required("El campo de email es obligatorio")
                    .test("is-valid-email", "El correo electronico no es valido", (value) => {
                        if (!value) return false;
                        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
                    }),
            },
        ],
        [
            {
                "type": SELECT_INPUT_TYPE,
                "name": "roleId",
                "label": "Rol",
                "options": roles,
                "isHorizontal": true,
                "sizing": { "sm": 8 },
                "labelSizing": { "sm": 3 },
                "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
            },
        ],
    ];

    if (!isEdit) {
        fields.push([
            {
                "type": SECRET_INPUT_TYPE,
                "name": "password",
                "label": "Contraseña",
                "isHorizontal": true,
                "sizing": { "sm": 8 },
                "labelSizing": { "sm": 3 },
                "validation": Yup.string().when("sendInvite", {
                    is: (sendInvite: unknown) => !sendInvite,
                    then: (s) => s
                        .required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR)
                        .matches(PASSWORD_REGEX, PASSWORD_ERROR),
                    otherwise: (s) => s.notRequired().test(
                        "password-optional-validation",
                        PASSWORD_ERROR,
                        (value) => {
                            if (!value) return true;
                            return PASSWORD_REGEX.test(value);
                        }
                    ),
                }),
            },
        ]);
        fields.push([
            {
                "type": "checkbox",
                "name": "sendInvite",
                "label": "Enviar invitación por correo",
                "sizing": { "sm": { "offset": 3 } },
            },
        ]);
    }

    return {
        sections: [
            {
                hideBorderBottom: true,
                fields,
            },
        ],
    };
};
